import React, { useState } from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../auth/AuthContext';
import { useLanguage } from '../../context/LanguageContext';
import Input from '../../components/common/Input';
import Button from '../../components/common/Button';
import './Login.css';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const { t } = useLanguage();
  const navigate = useNavigate();
  const location = useLocation();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const data = await login({ email, password });
      const from = location.state?.from;
      const redirectPath = from
        ? `${from.pathname || '/user/dashboard'}${from.search || ''}${from.hash || ''}`
        : data.user?.role === 'admin'
          ? '/admin/dashboard'
          : data.user?.role === 'coworker'
            ? '/admin/orders'
            : '/user/dashboard';

      navigate(redirectPath, { replace: true });
    } catch (err) {
      console.error('Login error:', err.response?.data || err);
      const errorMsg = err.response?.data?.message || err.response?.data?.error || t('login.failed');
      setError(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-header">
          <h1>{t('login.welcome')}</h1>
          <p>{t('login.subtitle')}</p>
        </div>

        {error && (
          <div className="error-message">
            <span>⚠️</span>
            <p>{error}</p>
          </div>
        )}

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <Input
              label={t('common.email')}
              type="email"
              autoComplete="username"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="your@email.com"
            />
          </div>

          <div className="form-group">
            <Input
              label={t('common.password')}
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              placeholder="••••••••"
            />
          </div>

          <div className="form-footer">
            <label className="remember-me">
              <input type="checkbox" />
              <span>{t('login.remember')}</span>
            </label>
            <Link to="/forgot-password" className="forgot-link">
              {t('login.forgot')}
            </Link>
          </div>

          <Button type="submit" disabled={loading} className="login-button">
            {loading ? t('login.loading') : t('login.submit')}
          </Button>
        </form>

        <div className="login-divider">
          <span>{t('common.or')}</span>
        </div>

        <p className="register-prompt">
          {t('login.noAccount')}{' '}
          <Link to="/register" className="register-link">
            {t('login.createOne')}
          </Link>
        </p>
      </div>
    </div>
  );
};

export default Login;
